import { render } from "./adminList.vue?vue&type=template&id=2b0b1436&ts=true"
import script from "./adminList.vue?vue&type=script&lang=ts&config=true"
export * from "./adminList.vue?vue&type=script&lang=ts&config=true"

import "./adminList.vue?vue&type=style&index=0&id=2b0b1436&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__